import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@myrealtrip/fetch';

interface TagStyle {
  backgroundColor: string;
  textColor: string;
}

export interface ProductTag {
  text: string;
  style: TagStyle;
}

export interface RecentViewProduct {
  gid: number;
  gpid: string;
  imageUrl: string;
  title: string;
  productUrl: string;
  discountPercent: string | null;
  discountText: string;
  reviewStar: string;
  reviewCount: number;
  inUserWishlist: boolean;
  tags: ProductTag[];
  systemProvider: string;
  manualRegistered: string;
}

interface RecentView {
  product: RecentViewProduct;
}

interface RecentViewsResponse {
  data: {
    recentOffers: RecentView[];
  };
  meta: Record<string, unknown>;
  result: { status: number; message: string; code: string };
}

const fetchRecentViewProducts = () => {
  return axiosInstance.get<RecentViewsResponse>('/discovery/api/v1/web/main/recent');
};

export default function useGetRecentViewProducts() {
  const { data, isLoading } = useQuery({
    queryKey: ['recentViewProducts'],
    queryFn: fetchRecentViewProducts,
    select: (response) =>
      (response.data.data?.recentOffers ?? []).map(
        (offer): RecentViewProduct => ({
          gid: offer.product.gid,
          gpid: offer.product.gpid,
          imageUrl: offer.product.imageUrl,
          title: offer.product.title,
          productUrl: offer.product.productUrl,
          discountPercent: offer.product.discountPercent,
          discountText: offer.product.discountText,
          reviewStar: offer.product.reviewStar,
          reviewCount: offer.product.reviewCount,
          inUserWishlist: offer.product.inUserWishlist,
          tags: offer.product.tags,
          systemProvider: offer.product.systemProvider,
          manualRegistered: offer.product.manualRegistered,
        }),
      ),
  });

  return {
    products: data ?? [],
    isLoading,
  };
}
